import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CCOContainer from "../../fundamentals/CCOContainer";
import HomeIcon from '@mui/icons-material/Home';
import useWindowSize from "../../../utility/useWindowSize";
import {CmLinkableType} from "../../types";
import {useNavigationTracking} from "tracking/hooks/useNavigationTracking";
import {useTranslation} from "react-i18next";

interface Props {
    target: CmLinkableType
}

const BREADCRUMB_STYLE = {
    m: 1,
    py: 2,
    '.MuiBreadcrumbs-separator, .MuiBreadcrumbs-li': {
        color: 'text.primary'
    }
}

function Breadcrumb(props: Props) {
    const {trackBreadcrumb} = useNavigationTracking();
    const {t} = useTranslation();
    const navigationLength = props.target.navigationPath?.length ?? 0;
    const {lowerThanWindowSmall} = useWindowSize()
    if (navigationLength <= 1) {
        return null
    }

    const breadcrumbMaxItems = lowerThanWindowSmall ? 2 : 4;

    return (
        <CCOContainer width={"full"} withMobilePadding border={true}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>}
                         maxItems={breadcrumbMaxItems}
                         aria-label="breadcrumb"
                         sx={BREADCRUMB_STYLE}>
                {
                    props.target.navigationPath!.map((item, index) =>
                                                         (index < navigationLength - 1) ?
                                                             (index == 0) ?
                                                                 <CCOLinkable key={item!.id}
                                                                              target={item!}
                                                                              ariaLabel={t(
                                                                                  'breadcrumb_home_aria') ??
                                                                                         ''}
                                                                              onClick={() => trackBreadcrumb(
                                                                                  (item as any).teaserTitle)}>
                                                                     <HomeIcon sx={{mt: 1}}/>
                                                                 </CCOLinkable>
                                                                 :
                                                                 <CCOLinkable key={item!.id}
                                                                              target={item!}
                                                                              type={"breadcrumb"}
                                                                              name={(item as any).teaserTitle}
                                                                              onClick={() => trackBreadcrumb(
                                                                                  (item as any).teaserTitle)}/>
                                                             : <Typography key={item!.id}
                                                                           variant={"subtitle2"}
                                                                           component={'p'}
                                                                           sx={{
                                                                               color: 'text.primary'
                                                                           }}>{(item as any).teaserTitle}</Typography>)
                }
            </Breadcrumbs>
        </CCOContainer>
    );
}

export default Breadcrumb